import { resourceReducer, getResources } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const simoSubs = resourceReducer('quickSubs', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default simoSubs;

export const getQuickSub = (state, id) => state.resources[id];
export const getAllQuickSubs = (state, page = 1) =>
  getResources(state, `page${page}`);
export const getQuickSubNotFoundFromFind = (state) =>
  Boolean(
    state.requests &&
      state.requests.find &&
      state.requests.find.statusCode === 404,
  );
export const getCreatedQuickSub = (state) =>
  state.requests.create &&
  state.requests.create.status === 'SUCCEEDED' &&
  state.resources[state.requests.create.ids[0]];
export const getAllQuickInitialsSubs = (state) =>
  getResources(state, `allQuickInitialsSubs`);
export const getAllQuickInitialsSubsStatus = (state) =>
  state.requests.fetchAllQuickInitialsSubs &&
  state.requests.fetchAllQuickInitialsSubs.status;
export const getSearchQuickSubs = (state, page = 1) =>
  getResources(state, `searchPage${page}`);
export const getFilteredQuickSubs = (state, filter, page) =>
  getResources(state, `${filter}Subs${page}`);
export const getQuickPortResponse = (state, subId) =>
  state.requests[`updatePort${subId}`];
export const getQuickSubUpcomingPlan = (state, subId) =>
  state.meta[subId] && state.meta[subId].upcomingPlan;
export const getQuickSubServiceCodes = (state, subId) =>
  state.meta[subId] && state.meta[subId].serviceCodes;
export const getQuickSubRunningActions = (state, subId) =>
  state.meta[subId] && state.meta[subId].runningActions;
export const getQuickPortData = (state, subId) =>
  state.meta[subId] && state.meta[subId].portData;
export const getQuickMdnHistory = (state, subId) =>
  state.meta[subId] && state.meta[subId].mdnHistory;
export const getQuickSyncStatusResponse = (state, subId) =>
  state.meta[subId] && state.meta[subId].syncStatus;
